var map = {
	"./alexa.png": 3931,
	"./angular.png": 1236,
	"./aws.png": 6074,
	"./bitbucket.png": 3733,
	"./csharp-1.png": 2915,
	"./csharp.png": 7225,
	"./css.png": 2687,
	"./docker-1.png": 7142,
	"./docker.png": 1768,
	"./git.png": 6446,
	"./html.png": 5887,
	"./html5.png": 2146,
	"./java.png": 8768,
	"./javascript.png": 2721,
	"./jenkins.png": 7148,
	"./mongodb.png": 6204,
	"./nlp.png": 6976,
	"./nodejs.png": 3033,
	"./postgresql.png": 4582,
	"./react.png": 6843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9291;